import dayjs from "dayjs";
import { dateFormate } from ".";

// create session vhnd uhnd
export const NAV_ITEMS_MODAL: any = [
    'Session Details'
];

export const status_type = {
    confirm: {
        session_status_name: 'confirm',
        session_status_code: 'confirmed'
    },
    cancle: {
        session_status_name: 'cancel',
        session_status_code: 'cancelled'
    },
    create: {
        session_status_name: 'create',
        session_status_code: 'created'
    }
};

export const filter_type = {
    all: 'all',
    vhnd: 'vhnd',
    uhnd: 'vhnd',
    outreach: 'outreach'
}

export const session_form_details = {
    sessionType: {
        '#type': 'select',
        '#title': 'Session Type',
        '#webform_key': 'sessionType',
        '#multiDropdown': false,
        '#options': [],
        '#required': true,
        '#isDisabled': false,
    },
    sessionName: {
        '#type': 'textfield',
        '#title': 'Session Name',
        '#webform_key': 'sessionName',
        '#required': true,
        '#isDisabled': false,
    },
    sessionDate: {
        '#type': 'date',
        '#title': 'Session Planned Date',
        '#webform_key': 'sessionDate',
        '#required': true,
        '#isDisabled': false,
        '#minDate': dayjs(new Date()).add(1, 'day').format(dateFormate.yyyy_mm_dd)
    },
    sessionHeld: {
        '#type': 'checkbox',
        '#title': 'Session to be held at facility.',
        '#webform_key': 'sessionHeld',
        '#required': false,
        '#isDisabled': false,
    },
    sessionMap: {
        '#isDisabled': false,
    },
    sessionHeldAt: {
        '#type': 'select',
        '#title': 'Session Held At',
        '#webform_key': 'sessionHeldAt',
        '#multiDropdown': false,
        '#options': [],
        '#required': true,
        '#isDisabled': false,
    },
    sessionSiteAddress: {
        '#type': 'textfield',
        '#title': 'Session Site Address',
        '#webform_key': 'sessionSiteAddress',
        '#required': true,
        '#isDisabled': false,
    },
    hpTagged: {
        '#type': 'select',
        '#title': 'Health Provider Tagged',
        '#webform_key': 'hpTagged',
        '#multiDropdown': true,
        '#options': [],
        '#required': true,
        '#isDisabled': false,
    },
    mobiliserTagged: {
        '#type': 'select',
        '#title': 'Mobiliser Tagged',
        '#webform_key': 'mobiliserTagged',
        '#multiDropdown': true,
        '#options': [],
        '#required': true,
        '#isDisabled': false,
    },
    vilagesCovered: {
        '#type': 'select',
        '#title': 'Villages Covered',
        '#webform_key': 'vilagesCovered',
        '#multiDropdown': true,
        '#options': [],
        '#required': false,
        '#isDisabled': false,
    },
    wardsCovered: {
        '#type': 'select',
        '#title': 'Wards Covered',
        '#webform_key': 'wardsCovered',
        '#multiDropdown': true,
        '#options': [],
        '#required': false,
        '#isDisabled': false,
    },
    sessionSiteCoverageArea: {
        '#type': 'textfield',
        '#title': 'Coverage Area',
        '#webform_key': 'sessionSiteCoverageArea',
        '#required': true,
        '#isDisabled': false,
    },
};

export const session_form_state = {
    sessionType: {
        isError: false,
        message: '',
        value: '',
    },
    sessionName: {
        isError: false,
        message: '',
        value: '',
    },
    sessionDate: {
        isError: false,
        message: '',
        value: '',
    },
    sessionHeld: {
        isError: false,
        message: '',
        value: '',
    },
    sessionHeldAt: {
        isError: false,
        message: '',
        value: '',
    },
    sessionSiteAddress: {
        isError: false,
        message: '',
        value: '',
    },
    lattitude: {
        isError: false,
        message: '',
        value: '',
    },
    longitude: {
        isError: false,
        message: '',
        value: '',
    },
    pincode: {
        isError: false,
        message: '',
        value: '',
    },
    hpTagged: {
        isError: false,
        message: '',
        value: '',
    },
    mobiliserTagged: {
        isError: false,
        message: '',
        value: '',
    },
    vilagesCovered: {
        isError: false,
        message: '',
        value: '',
    },
    wardsCovered: {
        isError: false,
        message: '',
        value: '',
    },
    sessionSiteCoverageArea: {
        isError: false,
        message: '',
        value: '',
    },
    coverageArea: {
        isError: false,
        message: '',
        value: '',
    }
};

export const session_message = {
    sessionType: {
        message: 'Enter valid session type.'
    },
    sessionName: {
        message: 'Enter valid session name.',
        messageForDuplicateName: 'Please change session name to create duplicate session.'
    },
    sessionDate: {
        message: 'Enter valid session date.',
        messageForDuplicateDate: 'Please change session date to create duplicate session.'
    },
    sessionHeldAt: {
        message: 'Enter valid session held at.'
    },
    sessionSiteAddress: {
        message: 'Enter valid session site address.',
        messageForSuggestion: 'please select from the address suggested.'
    },
    hpTagged: {
        message: 'Enter valid health provider.'
    },
    mobiliserTagged: {
        message: 'Enter valid mobiliser tagged.'
    },
    vilagesCovered: {
        message: 'Enter valid vilages covered.'
    },
    wardsCovered: {
        message: 'Enter valid wards covered.'
    },
    sessionSiteCoverageArea: {
        message: 'Enter valid coverage area.',
        message2: 'Coverage area either not created or areas are updated, please create or update in map to proceed.'
    },
    sessionCreationSuccessMessage: 'Session site added successfully.',
    sessionCreationUpdateMessage: 'Session site updated successfully.',
    duplicateSessionCreationSuccessMessage: 'Duplicate session site added successfully.',
    errorMessageHpTagged: 'Error in get health provider data.',
    errorMessagemobiliserTagged: 'Error in get mobiliser tagged data.',
    errorMessageVillage: 'Error in get village coverage data.',
    errorMessageWard: 'Error in get ward coverage data.',
    errorMessageFacilityLocation: 'Error in get facility location data.',
    errorMessageSessionType: 'Error in get session type data.',
    errorMessageSessionHeldAt: 'Error in get session held at session site data.',
    errorMessageSessionDownload: 'Error in downloading session site data.',
    errorMessageSessionCalender: 'Error in get session calender data.',
    errorMessageSessionCalenderSearch: 'Error in get session search data.',
    errorMessageSessionDetails: 'Error in session site details.',
    errorMessageSessionStatus: 'Error in get session site status.',
    errorMessageSessionDetailsByDate: 'Error in get session details by date.',
    errorMessageCreateMessage: 'Error in creating session',
    errorMessagecancleStatusMessage: 'Error in cancelling session',
    errorMessageconfirmStatusMessage: 'Error in confirming session',
    errorMessageDeleteStatusMessage: 'Error in deleting session',
    errorMessageUpdateMessage: 'Error in update session',
    sessionDeletedSuccessMessage: "Session deleted successfully."

};

// ==========================================